export interface LevelTwoConfig {
  newLogin: boolean;
  newRegister: boolean;
  newProfile: boolean;
  newFavorites: boolean;
  newDependents: boolean;
  newAppointments: boolean;
}

export type LevelTwoConfigKey = keyof LevelTwoConfig;

export const DISABLED_LEVEL_TWO_CONFIG: LevelTwoConfig = {
  newLogin: false,
  newRegister: false,
  newProfile: false,
  newFavorites: false,
  newDependents: false,
  newAppointments: false,
} as const;

export const ENABLED_LEVEL_TWO_CONFIG: LevelTwoConfig = {
  newLogin: true,
  newRegister: true,
  newProfile: true,
  newFavorites: true,
  newDependents: true,
  newAppointments: true,
} as const;

export interface VariantFlagEvaluationResult<T = unknown> {
  key: string;
  variant: string | null;
  attachment: T | null;
  match: boolean;
  isFallback: boolean;
  timestamp: number;
  reason?: string;
  evaluationTimeMs?: number;
  errorCode?: string;
  errorMessage?: string;
}

export interface UseLevelTwoResult {
  config: LevelTwoConfig;
  loading: boolean;
  error: Error | null;
  isFallback: boolean;
  refetch: () => Promise<void>;
  variant: string | null;
}
